import queryString from 'query-string';
import { all, call } from 'redux-saga/effects';
import { API } from '../../api';

export function* fetchGraph({
  serverConfig,
  filterString,
  graphDefinition,
  postpend = '',
  key,
}) {
  try {
    const graphPath = `/report/${
      serverConfig.namespace
    }?${queryString.stringify({
      graphs: graphDefinition.graph,
      layer_id: key,
    })}${filterString ? `&${filterString}` : ''}`;

    const graphResult = yield call(API, 'get', 'api', graphPath);

    graphResult.graphs = graphResult.graphs.map((g) => ({
      ...g,
      name: `${graphDefinition.name}${postpend}`,
    }));

    graphResult.graphs = graphResult.graphs.map((graph) => ({
      ...graph,
      data: graph.data.map((point) => {
        if (graphDefinition.unit === '%') {
          // eslint-disable-next-line no-param-reassign
          point.value *= 100;
        }
        // eslint-disable-next-line no-param-reassign
        point.group_by = `${point.group_by}`;
        return point;
      }),
    }));

    if (graphDefinition.renameColumn) {
      graphResult.graphs = graphResult.graphs.map((graph) => ({
        ...graph,
        data: graph.data.map((dataPoint) => ({
          ...dataPoint,
          column: graphDefinition.renameColumn,
        })),
      }));
    }

    if (graphDefinition.after) {
      graphResult.graphs = graphResult.graphs.map((graph) => ({
        ...graph,
        data: graph.data.filter(
          (point) => point.group_by &&
            point.group_by.slice(0, 4) > graphDefinition.after,
        ),
      }));
    }

    return graphResult.graphs;
  } catch (e) {
    console.error('Error fetching graphs for multiparcel report', e);
    return null;
  }
}

export function* fetchGraphs({
  report,
  serverConfig,
  filterString,
  key,
}) {
  const graphsCalls = report.sections.reduce((acc, section) => {
    section.properties.forEach((graphDefinition) => {
      if (graphDefinition && !!graphDefinition.graph && graphDefinition.type.includes('GRAPH')) {
        const finalFilterString = graphDefinition.filter
          ? `${filterString}&${graphDefinition.filter}`
          : filterString;
        acc.push(
          call(fetchGraph, {
            key,
            serverConfig,
            filterString: finalFilterString,
            report,
            graphDefinition: {
              ...graphDefinition,
              name: graphDefinition.graph,
            },
          }),
        );

        (graphDefinition.compare || []).forEach((compare) => {
          acc.push(
            call(fetchGraph, {
              serverConfig,
              filterString: compare.useFilters ? finalFilterString : '',
              report,
              graphDefinition: {
                ...graphDefinition,
                graph: compare.graph || graphDefinition.graph,
                name: graphDefinition.graph,
              },
              postpend: `_${compare.to.toLowerCase()}`,
            }),
          );
        });
      }
    });
    return acc;
  }, []);
  const results = yield all(graphsCalls);
  return results;
}
